
const formChecked = document.querySelectorAll('[data-confirm]')
const arrayChecked = Array.from(formChecked)
const submit = document.querySelector('#submitBtn')
const directCheckout = document.querySelector('#direct-checkout-button')

if(arrayChecked.length > 0){
  if (submit) submit.disabled = true
  if (directCheckout) directCheckout.disabled = true
}

function func1() {
  const decision = arrayChecked.every(function(value){
    if(value.dataset.confirm === "must"){
      return value.checked == true
    }
    return true
  })
  if(decision){
   if (submit) submit.disabled = false
   if (directCheckout) directCheckout.disabled = false
  }else{
   if (submit) submit.disabled = true
   if (directCheckout) directCheckout.disabled = true
  }
}

const ALL_DAY_TIME = '終日OK'

function isPlaceholderValue(val) {
  if (!val) return true
  const trimmed = String(val).trim()
  return trimmed === '' || trimmed === 'ご選択下さい'
}

function getValidOptionValues(selectEl) {
  if (!selectEl) return []
  return Array.from(selectEl.options)
    .map(function (opt) { return opt.value })
    .filter(function (val) { return !isPlaceholderValue(val) })
}

function updateSelectOptions(selectEl, isUnavailable) {
  if (!selectEl) return
  Array.from(selectEl.options).forEach(function (opt) {
    opt.disabled = !isPlaceholderValue(opt.value) && isUnavailable(opt.value)
  })
}

function resetSelectToPlaceholder(selectEl) {
  if (!selectEl) return
  const placeholderOpt = Array.from(selectEl.options).find(function (opt) {
    return isPlaceholderValue(opt.value)
  })
  if (placeholderOpt) {
    selectEl.value = placeholderOpt.value
  } else {
    selectEl.selectedIndex = 0
  }
}

function resetPreferredDate(dateEl) {
  if (dateEl.tagName === 'SELECT') {
    resetSelectToPlaceholder(dateEl)
  } else {
    dateEl.value = ''
  }
}

function syncExclusiveSelectGroup(selectElements, changedSelect) {
  if (!selectElements || selectElements.length < 2) return

  if (changedSelect && !isPlaceholderValue(changedSelect.value)) {
    const picked = changedSelect.value
    const hasConflict = selectElements.some(function (el) {
      return el !== changedSelect && el.value === picked
    })
    if (hasConflict) {
      resetSelectToPlaceholder(changedSelect)
    }
  }

  const seen = new Set()
  selectElements.forEach(function (el) {
    if (isPlaceholderValue(el.value)) return
    if (seen.has(el.value)) {
      resetSelectToPlaceholder(el)
    } else {
      seen.add(el.value)
    }
  })

  selectElements.forEach(function (el) {
    const otherValues = new Set()
    selectElements.forEach(function (other) {
      if (other !== el && !isPlaceholderValue(other.value)) {
        otherValues.add(other.value)
      }
    })
    updateSelectOptions(el, function (value) {
      return otherValues.has(value)
    })
  })
}

function getPreferredDate(row) {
  return String(row.dateEl.value || '').trim()
}

function getOtherRowsWithDate(groupRows, targetRow, dateStr = getPreferredDate(targetRow)) {
  if (isPlaceholderValue(dateStr)) return []
  return groupRows.filter(function (row) {
    return row !== targetRow && getPreferredDate(row) === dateStr
  })
}

function getTakenPreferredTimes(rows) {
  const takenTimes = new Set()
  rows.forEach(function (row) {
    if (row.timeEl && !isPlaceholderValue(row.timeEl.value)) {
      takenTimes.add(row.timeEl.value)
    }
  })
  return takenTimes
}

function isDateUnavailableForRow(groupRows, targetRow, candidateDateStr) {
  const dateStr = String(candidateDateStr || '').trim()
  if (isPlaceholderValue(dateStr)) return false

  const otherRowsWithDate = getOtherRowsWithDate(groupRows, targetRow, dateStr)
  if (!targetRow.timeEl) {
    return otherRowsWithDate.length > 0
  }

  const takenTimes = getTakenPreferredTimes(otherRowsWithDate)
  if (takenTimes.has(ALL_DAY_TIME)) return true

  const validTimes = getValidOptionValues(targetRow.timeEl)
  if (validTimes.length === 0) return false

  const allTimesTaken = validTimes.every(function (timeVal) {
    return takenTimes.has(timeVal)
  })
  if (allTimesTaken) return true

  return isPlaceholderValue(getPreferredDate(targetRow)) && takenTimes.has(targetRow.timeEl.value)
}

function resetConflictingPreference(groupRows, changedRow, changedFieldType) {
  if (!changedRow || isPlaceholderValue(getPreferredDate(changedRow))) return

  if (changedFieldType === 'date' && isDateUnavailableForRow(groupRows, changedRow, getPreferredDate(changedRow))) {
    resetPreferredDate(changedRow.dateEl)
    return
  }

  const takenTimes = getTakenPreferredTimes(getOtherRowsWithDate(groupRows, changedRow))
  if (changedRow.timeEl && takenTimes.has(changedRow.timeEl.value)) {
    resetSelectToPlaceholder(changedRow.timeEl)
  }
}

function clearAllDayDateConflicts(groupRows) {
  // 終日OKを選択した日は、入力済みの他の希望日からも除外する。
  groupRows.forEach(function (row) {
    if (!row.timeEl || row.timeEl.value !== ALL_DAY_TIME) return
    getOtherRowsWithDate(groupRows, row).forEach(function (other) {
      resetPreferredDate(other.dateEl)
    })
  })
}

function syncDateTimeGroup(groupRows, changedRow, changedFieldType) {
  if (!groupRows || groupRows.length < 2) return

  const isDateOnlyGroup = groupRows.every(function (row) { return !row.timeEl })
  if (isDateOnlyGroup) {
    const dateSelects = groupRows
      .map(function (row) { return row.dateEl })
      .filter(function (el) { return el && el.tagName === 'SELECT' })
    syncExclusiveSelectGroup(dateSelects, changedRow ? changedRow.dateEl : null)
    return
  }

  resetConflictingPreference(groupRows, changedRow, changedFieldType)
  clearAllDayDateConflicts(groupRows)

  const seenCombos = new Set()
  groupRows.forEach(function (row) {
    if (!row.timeEl) return
    const dateStr = getPreferredDate(row)
    const timeValue = row.timeEl.value
    if (isPlaceholderValue(dateStr) || isPlaceholderValue(timeValue)) return
    const comboKey = dateStr + '___' + timeValue
    if (seenCombos.has(comboKey)) {
      resetSelectToPlaceholder(row.timeEl)
    } else {
      seenCombos.add(comboKey)
    }
  })

  groupRows.forEach(function (row) {
    if (row.dateEl.tagName === 'SELECT') {
      updateSelectOptions(row.dateEl, function (value) {
        return isDateUnavailableForRow(groupRows, row, value)
      })
    }

    const takenTimes = getTakenPreferredTimes(getOtherRowsWithDate(groupRows, row))
    updateSelectOptions(row.timeEl, function (value) {
      return takenTimes.has(value)
    })
  })
}

const dateInputRowMap = new Map()

function initDuplicatePrevention() {
  const locationSelects = Array.from(
    document.querySelectorAll(
      'select[name="properties[場所第1候補]"], select[name="properties[場所第2候補]"]'
    )
  )
  if (locationSelects.length > 1) {
    locationSelects.forEach(function (selectEl) {
      selectEl.addEventListener('change', function () {
        syncExclusiveSelectGroup(locationSelects, selectEl)
      })
    })
    syncExclusiveSelectGroup(locationSelects, null)
  }

  const wraps = Array.from(document.querySelectorAll('.datepicker-wrap'))
  const groupsByKey = new Map()

  Array.from(document.querySelectorAll('.datepicker')).forEach(function (datepickerEl) {
    const dateEl = datepickerEl.querySelector('.datepicker-menu1 input, .datepicker-menu1 select')
    if (!dateEl) return
    const timeEl = datepickerEl.querySelector('.datepicker-menu2 select')
    const wrapEl = datepickerEl.closest('.datepicker-wrap')
    const wrapIndex = wrapEl ? wraps.indexOf(wrapEl) : -1
    const isSecondSession = Boolean(dateEl.name && dateEl.name.indexOf('(2)') !== -1)
    const groupKey = wrapIndex + ':' + (isSecondSession ? '2' : '1')

    if (!groupsByKey.has(groupKey)) {
      groupsByKey.set(groupKey, [])
    }
    const groupRows = groupsByKey.get(groupKey)
    const rowObj = {
      dateEl: dateEl,
      timeEl: timeEl,
      groupRows: groupRows
    }
    groupRows.push(rowObj)
    dateInputRowMap.set(dateEl, rowObj)
  })

  groupsByKey.forEach(function (groupRows) {
    if (groupRows.length < 2) return
    groupRows.forEach(function (row) {
      row.dateEl.addEventListener('change', function () {
        syncDateTimeGroup(groupRows, row, 'date')
      })
      if (row.timeEl) {
        row.timeEl.addEventListener('change', function () {
          syncDateTimeGroup(groupRows, row, 'time')
        })
      }
    })
    syncDateTimeGroup(groupRows, null, null)
  })
}

window.canSelectPreferredDate = function (inputEl, candidateDateStr) {
  const rowObj = dateInputRowMap.get(inputEl)
  if (!rowObj) return true
  return !isDateUnavailableForRow(rowObj.groupRows, rowObj, candidateDateStr)
}

initDuplicatePrevention()
